import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'userId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'userId'}
            direction={order}
            onClick={() => {
              onRequestSort('userId');
            }}
          >
            ユーザーID　(数字）
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'accountId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'accountId'}
            direction={order}
            onClick={() => {
              onRequestSort('accountId');
            }}
          >
            アカウントID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'displayName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'displayName'}
            direction={order}
            onClick={() => {
              onRequestSort('displayName');
            }}
          >
            名前
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'email' ? order : false}>
          <TableSortLabel
            active={orderBy === 'email'}
            direction={order}
            onClick={() => {
              onRequestSort('email');
            }}
          >
            メールアドレス
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'status' ? order : false}>
          <TableSortLabel
            active={orderBy === 'status'}
            direction={order}
            onClick={() => {
              onRequestSort('status');
            }}
          >
            ステータス
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'message' ? order : false}>
          <TableSortLabel
            active={orderBy === 'message'}
            direction={order}
            onClick={() => {
              onRequestSort('message');
            }}
          >
            自己紹介メッセージ
          </TableSortLabel>
        </TableCell>
        {/* <TableCell sortDirection={orderBy === 'gochiTotal' ? order : false}>
          <TableSortLabel
            active={orderBy === 'gochiTotal'}
            direction={order}
            onClick={() => {
              onRequestSort('gochiTotal');
            }}
          >
            通算ごち数 / 通算ごち金額（税抜金額）
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'latestGochiDate' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'latestGochiDate'}
            direction={order}
            onClick={() => {
              onRequestSort('latestGochiDate');
            }}
          >
            最新ごち日
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'useGochiTotal' ? order : false}>
          <TableSortLabel
            active={orderBy === 'useGochiTotal'}
            direction={order}
            onClick={() => {
              onRequestSort('useGochiTotal');
            }}
          >
            通算ごちられ数 / 通算ごちられ金額（税抜金額）
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'latestUseGochiDate' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'latestUseGochiDate'}
            direction={order}
            onClick={() => {
              onRequestSort('latestUseGochiDate');
            }}
          >
            最新ごちられ日
          </TableSortLabel>
        </TableCell> */}
        <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'createdAt'}
            direction={order}
            onClick={() => {
              onRequestSort('createdAt');
            }}
          >
            登録日時
          </TableSortLabel>
        </TableCell>
        <TableCell />
        <TableCell>ごちめしユーザのQRコード</TableCell>
        <TableCell>こどもごちめしQRコード</TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
